import { useNavigate } from 'react-router-dom'
import AppCard from 'ui/AppCard'

const MilkingScheduleCard = () => {
	const navigate = useNavigate()

	return (
		<AppCard
			title='Расписание доений'
			description='Настройте расписание доений по сменам.'
			onClick={() => navigate('/settings/milking-schedule')}
		/>
	)
}

export default MilkingScheduleCard
